import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import roTranslation from './locales/ro/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';
import itTranslation from './locales/it/translation.json';

const getInitialLanguage = (): string => {
  // Check if user has a saved preference 
  // if stories are not generated in the correct language, comment next 4 lines and investigate
  const savedLang = localStorage.getItem('preferredLanguage');
  if (savedLang && ['en', 'ro', 'de', 'fr', 'es', 'it'].includes(savedLang)) {
    return savedLang;
  }

  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (['ro', 'de', 'fr', 'es', 'it'].includes(browserLang)) {
    return browserLang;
  }

  // Default to English
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ro: { translation: roTranslation },
      de: { translation: deTranslation },
      fr: { translation: frTranslation },
      es: { translation: esTranslation },
      it: { translation: itTranslation },
    },

    lng: getInitialLanguage(),                 // Force initial language
    fallbackLng: "en",
    detection: { order: [], caches: [] },  // Disable detection

    supportedLngs: ['en', 'ro', 'de', 'fr', 'es', 'it'],
    nonExplicitSupportedLngs: true,

    interpolation: { escapeValue: false }
  });

export default i18n;